import { render } from "./upload2.vue?vue&type=template&id=4859ef39&scoped=true"
import script from "./upload2.vue?vue&type=script&lang=js"
export * from "./upload2.vue?vue&type=script&lang=js"

import "./upload2.vue?vue&type=style&index=0&id=4859ef39&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4859ef39"]])

export default __exports__